import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {Delivery} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/delivery.types';
import {
  getDayDifferencesBetweenDates,
  isWithinXDays,
  useTranslation,
} from '@aboutyou/i18n';
import {useEffect} from 'react';

export interface DeliveryWithDayFlag extends Delivery {
  showDatesAsDays?: boolean;
  showDateAsDayTitle?: string;
}

export const useShowDeliveriesAsDayDates = (deliveries: Delivery[]) => {
  const HAS_END_DELIVERY_WITHIN_THREE_DAYS = deliveries.some(delivery =>
    isWithinXDays(delivery.deliveryPeriod.endDate, 3),
  );
  const {t} = useTranslation();
  const {isActive, activateAbTest} = useIsFeatureActive(
    'show_basket_delivery_as_days',
  );

  useEffect(() => {
    if (HAS_END_DELIVERY_WITHIN_THREE_DAYS && !isActive) {
      activateAbTest();
    }
  }, []);

  return deliveries.map((delivery: DeliveryWithDayFlag) => {
    if (isActive && isWithinXDays(delivery.deliveryPeriod.endDate, 3)) {
      delivery.showDatesAsDays = true;

      const [startDateDistance, endDateDistance] = [
        getDayDifferencesBetweenDates(
          new Date(),
          delivery.deliveryPeriod.startDate,
        ),
        getDayDifferencesBetweenDates(
          new Date(),
          delivery.deliveryPeriod.endDate,
        ),
      ];

      if (endDateDistance === 1 || startDateDistance === endDateDistance) {
        // These conditions should not happen, but to avoid any chance of weird translations
        delivery.showDatesAsDays = false;
      } else {
        delivery.showDateAsDayTitle = t(
          `Arrives in {startDateDistance} - {endDateDistance} days`,
          {endDateDistance, startDateDistance},
        );
      }
    }
    return delivery;
  });
};
